// JavaScript source code
import React, { useState, useEffect} from 'react';
import { Link, useParams, useLocation  } from 'react-router-dom';
import SubHeader from '../components/subheader';
import SubFooter from '../components/subfooter';
import LeftNav from '../components/leftnav';
import SearchInput from '../components/searchInput';
import config from '../config';
import Cart from '../components/cart';
import LoadingOverlay from '../components/loadingOverlay';
import MessageDialog from '../components/messageDialog';
import LoginDialog from '../components/loginDialog';
import { get, getUser, getCart} from '../request';
function MallList(props) {
    const activeIndex = 2;
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let productLogo = 0;
    const [cartlist, setCartlist] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setShowLoading] = useState(false);
    let categoryId = searchParams.get('categoryId');
    let productType = searchParams.get('productType');
    const [currentDId, setCurrentDId] = useState(0);

    if (productType == 31 || productType == 32) {
        categoryId = 3;
        if (productType == 32) {
            productLogo = 2;
        }
        if (productType == 31) {
            productLogo = 1;
        }
    }
    else {
        if (!categoryId) {
            categoryId = productType;
        }
    }
    const authorization = localStorage.getItem("Authorization");
    var user = getUser();
    let searchItem,searchedStr;
    
    const showPrice = authorization != null && user != null && user.userType == 1
        && user.business.businessStatus == 0;
    const [products, setData] = useState([]); // 初始化数据状态为null
    const [allProducts, setData1] = useState([]); // 初始化数据状态为null
    const [isShowLogin, setIsShowLogin] = useState(false);
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        var cDid=0;
        if (user && user.canBuyDepartmentIds && user.canBuyDepartmentIds.length > 0) {
            if (localStorage.getItem("currentDId") && localStorage.getItem("currentDId")!="null") {
                setCurrentDId(localStorage.getItem("currentDId"));
                cDid = localStorage.getItem("currentDId");
                localStorage.setItem("currentDId", null);
            }
            else {
                setCurrentDId(user.canBuyDepartmentIds[0].id); //23,24,25
                cDid = user.canBuyDepartmentIds[0].id;
            }
        }
        if (showPrice) {
            if (categoryId) {
                setShowLoading(true);
                get("delianapi/product/mylist-" + categoryId)
                    .then(response => {
                        setShowLoading(false);
                        if (productLogo == 1) {
                            response.items = response.items.filter(function (item) {
                                return item.productLogo == "汽机油";
                            });
                        }
                        else if (productLogo == 2) {
                            response.items = response.items.filter(function (item) {
                                return item.productLogo == "柴机油";
                            });
                        }
                        for (var i = 0; i < response.items.length; i++) {
                            setPrice(response.items[i]);
                        }
                        var theProducts = response.items.filter(function (p) { return !p.isCanPoints && p.productSkuList.length > 0; });
                        theProducts.forEach(function (product) {
                            product.nameHtml = { __html: product.name }
                        });
                        setData(theProducts);
                        setData1(theProducts);
                        if (localStorage.getItem("keyword") && localStorage.getItem("keyword") != "null") {
                            setInputValue(localStorage.getItem("keyword"));
                            localStorage.setItem("keyword", null);
                            handleSearchClick();
                        } else {
                            if (cDid > 0) {
                                setData(theProducts.filter(function (p) {
                                    return cDid == p.departmentId;
                                }));
                            }
                        }

                    });
            }
        }
        else {
            if (categoryId) {
                setShowLoading(true);
                get("delianapi/product/list-" + categoryId).then(response => {
                    setShowLoading(false);

                    if (productLogo == 1) {
                        response.items = response.items.filter(function (item) {
                            return item.productLogo == "汽机油";
                        });
                    }
                    else if (productLogo == 2) {
                        response.items = response.items.filter(function (item) {
                            return item.productLogo == "柴机油";
                        });
                    }

                    for (var i = 0; i < response.items.length; i++) {
                        setNotLoginPrice(response.items[i]);
                    }
                    var theProducts = response.items;
                    theProducts.forEach(function (product) {
                        product.nameHtml = { __html: product.name }
                    });

                    setData(theProducts);
                    setData1(theProducts);
                    if (localStorage.getItem("keyword") && localStorage.getItem("keyword") != "null") {
                        setInputValue(localStorage.getItem("keyword"));
                        localStorage.setItem("keyword", null);
                        handleSearchClick();
                    }
                    else {
                        if (cDid > 0) {
                            setData(allProducts.filter(function (p) {
                                return cDid == p.departmentId;
                            }));
                        }
                    }
                });
            }
        }
        loadCart();
    }, [categoryId, productLogo]);
    
    const setPrice = (product) =>{
        var prices = [];
        for (var i = 0; i < product.productSkuList.length; i++) {
            if (product.productSkuList[i].isActive && product.productSkuList[i].servicePrice != null) {
                prices.push(product.productSkuList[i].servicePrice);
            }
            if (product.productSkuList[i].departmentId > 0) {
                product.departmentId = product.productSkuList[i].departmentId;
            }
        }
        product.minPrice = prices.length > 0 ? Math.min.apply(this, prices).toFixed(2) : null;
        product.maxPrice = prices.length > 0 ? Math.max.apply(this, prices).toFixed(2) : null;
    }
    const setNotLoginPrice = (product) => {
        var prices = [];
        for (var i = 0; i < product.productSkuList.length; i++) {
            if (product.productSkuList[i].isActive && product.productSkuList[i].price != null) {
                prices.push(product.productSkuList[i].price);
            }
            if (product.productSkuList[i].departmentId > 0) {
                product.departmentId = product.productSkuList[i].departmentId;
            }
        }
        product.minPrice = prices.length > 0 ? Math.min.apply(this, prices).toFixed(2) : null;
        product.maxPrice = prices.length > 0 ? Math.max.apply(this, prices).toFixed(2) : null;
    }
    const [searchStr, setInputValue] = useState('');
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }
    const handleClickDepartment = (did)=> {
        setCurrentDId(did);
        handleSearchClick(null,did);
    }
    const handleSearchClick = (event,did) => {
        searchItem = false;
        var cDid = currentDId;
        if (did) {
            cDid = did;
        }
        var search = searchStr.trim();
        if (search) {
            searchItem = true;
            var p = [];
            for (var i = 0; i < allProducts.length; i++) {
                if (allProducts[i].name.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0) {
                    if (cDid > 0 && cDid != allProducts[i].departmentId) {
                        continue;
                    }
                    p.push(allProducts[i]);
                }
            }
            setData( p);
            searchedStr = search;
        } else {
            if (cDid > 0) {
                setData(allProducts.filter(function (p) {
                    return cDid == p.departmentId;
                }));
            }
            else {
                setData(allProducts);
            }
        }

    }
    const loadCart = () => {
        if (user != null && user.userType == 1 && user.business.businessStatus == 0) {
            setShowLoading(true);
            getCart().then(function (response) {
                setShowLoading(false);
                if (response.statusCode !== 200) {
                    localStorage.setItem('user', null);
                    return;
                }
                setCartlist(response.items.filter(function (c) { return c.sku; }));
            });
        }
    }
    return (
        <div className="mallList" >
            <SubHeader activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="detail">
                    <LeftNav type={1} selectId={productType} />
                    <div className="product">
                        <div className="title">
                            { user && user.canBuyDepartmentIds && user.canBuyDepartmentIds.length > 0 &&
                                (<div className="logoList">
                                    {
                                    user.canBuyDepartmentIds.map((item, index) => (
                                        <div key={item.id }
                                            className={`logo logo${item.id} ${currentDId == item.id ? "current" : ""}`}
                                            onClick={() => handleClickDepartment(item.id)}>
                                            <span className="mobile-show">{item.name}</span>
                                        </div>
                                        )
                                    )
                                  }
                                </div>)                        
                            }
                            <div className="search">
                                {
                                    searchItem &&
                                    <div className="search-info" >
                                        <span className="bold" >{searchedStr}</span>"&nbsp;&nbsp;相关的产品：找到
                                        <span className="blue bold" >{products.length}</span>件
                                    </div>
                                }                                
                                <SearchInput inputValue={searchStr} onChange={handleInputChange}
                                    onClick={handleSearchClick} />
                            </div>
                        </div>                        
                            <div className="list">
                            {
                                products.map((product,index) => (
                                    <Link key={product.id} className="productdetail" to={config.root+ `/Product?id=${product.id}`}>
                                        {
                                            product.isCanPoints && <div className="integral-img"><div>积分兑换</div></div>
                                        }                                      

                                        <div className="img">
                                            {
                                                product.productImageList[0] &&
                                                <img src={`${product.productImageList[0].imageUrl.replace('.jpg', '.png')}.middle.png`} alt="" />
                                            }
                                        </div>
                                        <div className="name" dangerouslySetInnerHTML={product.nameHtml}></div>
                                            {
                                                //showPrice &&
                                                <div className="price" >
                                                <small >{product.isCanPoints ? '积分' : ''}</small>
                                                <span className="red"><small >{product.isCanPoints ? '' : '￥'}</small>
                                                    <span className="bold" >{product.minPrice}</span></span><small>&nbsp;&nbsp;起</small>
                                                </div>
                                            }
                                            {
                                                //!showPrice &&
                                                //<div className="price" >
                                                //    <span >暂无价格</span>
                                                //</div>
                                            }

                                    </Link>
                                ))                                
                            }
                            </div>
                        
                    </div>
                </div>
            </div>
            {
                showPrice &&
                <Cart num={cartlist.length} />
            }
            <SubFooter />
            <MessageDialog message={errorMessage} onCancel={() => {
                setErrorMessage("");
            }} />
            <LoadingOverlay isLoading={isLoading}>
            </LoadingOverlay>
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>          
    );
}

export default MallList;